import { cn } from '@/app/utils';
import type { HeroPresetPrompt } from '../../../../types';
import { encodeHttpMediaUrl } from '../../../../utils/media-url';

interface PresetPromptChipsProps {
  variant: 'oval' | 'square';
  presets: HeroPresetPrompt[];
  onClickPreset: (preset: HeroPresetPrompt) => void;
}

export function PresetPromptChips({ variant, presets, onClickPreset }: PresetPromptChipsProps) {
  return (
    <div className={cn('flex flex-wrap justify-start', variant === 'oval' ? 'gap-4 sm:gap-3' : 'gap-2')}>
      {presets?.map((preset, index) => (
        <button
          key={preset._key || `preset-${index}`}
          className={cn(
            'relative flex max-w-[170px] items-center justify-center overflow-hidden bg-white/[0.08] text-sm text-white backdrop-blur-[20px] transition-all hover:scale-105 hover:bg-white/[0.16] active:scale-100',
            variant === 'oval' ? 'rounded-full px-5 py-2' : 'size-10 rounded-[7px] px-2 py-0',
          )}
          onClick={() => onClickPreset(preset)}
          type="button"
        >
          {preset.thumbnail && (
            <img
              alt={preset.name || preset.promptText || 'Preset prompt'}
              className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-40"
              src={encodeHttpMediaUrl(preset.thumbnail)}
            />
          )}
          <span className="relative z-[1] truncate whitespace-nowrap leading-[1.4]">
            {preset.name || preset.promptText}
          </span>
        </button>
      ))}
    </div>
  );
}
